import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome'
import {
  faChartPie,
  faGamepad,
  faArrowDownShortWide,
  faArrowUpShortWide,
  faPause,
  faPlay,
  faSearch,
  faArrowRightToBracket,
  faClockRotateLeft,
  faCopy,
  faCoins,
  faAdd,
  faFileExport,
  faList,
  faArrowUp,
  faArrowDown,
  faEllipsis,
  faCircle,
  faUser,
  faBars,
  faMinus,
  faRotateRight,
  faChessBoard,
  faMessage,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons'
import { CommonModule } from '@angular/common'
import { RoutePathEnum } from '@shared/enums'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { SpinnerService } from '@shared/services/spinner.service'
import { AccountService } from '@core/services'
import { HeaderComponent } from './inbetween/components/header/header.component'
import { UserInitDataDto } from '@core/dtos'
import { ModalV2Component, ProfileManagementComponent } from '@shared/components'
import { ModalService } from '@shared/services'
import { ChipsComponent } from '@shared/components/profile/chips/chips.component'
import { TablesInfoComponent } from './inbetween/components/menu/tables-info/tables-info.component'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    FontAwesomeModule,
    CommonModule,
    MatProgressSpinnerModule,
    HeaderComponent,
    ModalV2Component,
    ProfileManagementComponent,
    ChipsComponent,
    TablesInfoComponent,
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass',
})
export class AppComponent implements OnInit {
  faArrowRightToBracket = faArrowRightToBracket
  title = 'inbetween-live'

  get authenticated(): boolean {
    return this._accountService.authenticated
  }
  get showHeader(): boolean {
    return (
      this.authenticated &&
      !this.router.url.includes(`/${RoutePathEnum.CARD_GAME}`) &&
      !this.router.url.includes(`/${RoutePathEnum.ADMIN}`) &&
      !this.router.url.includes(`/${RoutePathEnum.RUSH_MAIN}`)
    )
  }
  get tableInfoTitle(): string {
    return `${this._modalService.tableInfo?.tableName} Rules`
  }

  get buyInCost(): number {
    return this._modalService.tableInfo?.buyInCost || 0
  }
  get foldCost(): number {
    return this._modalService.tableInfo?.foldCost || 0
  }
  get minBet(): number {
    return this._modalService.tableInfo?.minBet || 0
  }
  get maxBet(): number {
    return this._modalService.tableInfo?.maxBet || 0
  }
  get showTableInfoModal(): boolean {
    return this._modalService.showTableInfoModal
  }
  get showTaskBar(): boolean {
    return this._accountService.isPlayer
  }
  get showProfileModal(): boolean {
    return this._modalService.showProfileModal
  }

  get showChipsModal(): boolean {
    return this._modalService.showChipsModal
  }

  get isLoggerPage(): boolean {
    return (
      this.authenticated &&
      (this.router.url.includes(`/${RoutePathEnum.LOGGER}`) ||
        this.router.url.includes(`/${RoutePathEnum.ADMIN}`))
    )
  }

  isShowSpinner = false
  userInitData?: UserInitDataDto

  constructor(
    library: FaIconLibrary,
    private readonly router: Router,
    public _spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private _accountService: AccountService,
    private _modalService: ModalService,
  ) {
    library.addIcons(
      faMessage,
      faChartPie,
      faGamepad,
      faArrowDownShortWide,
      faArrowUpShortWide,
      faPause,
      faPlay,
      faSearch,
      faClockRotateLeft,
      faCopy,
      faCoins,
      faAdd,
      faArrowRight,
      faFileExport,
      faList,
      faArrowUp,
      faArrowDown,
      faEllipsis,
      faCircle,
      faUser,
      faBars,
      faMinus,
      faChessBoard,
      faRotateRight,
    )
  }

  ngOnInit(): void {
    console.log('In Between Live Version 1.0.1')
    this._spinnerService.$isShowSpinner.subscribe((i) => {
      this.isShowSpinner = i
      this.cdr.detectChanges()
    })

    this._accountService.$userInitData.subscribe((i) => {
      this.userInitData = i
    })
  }

  closeModal() {
    this._modalService.closeModal()
  }

  closeChipsModal() {
    this._modalService.closeChipsModal()
  }
}
